
import { createSelector } from 'reselect'

const innerStateSelector = state => state.store;

const storeSelector = createSelector(
   innerStateSelector,
   state => state.store
);

const fetchingSelector = createSelector(
   innerStateSelector,
   state => state.isFetching
);
const isEmptySelector = createSelector(
   innerStateSelector,
   state => state.isEmpty
);
const newFetchingSelector = createSelector(
   innerStateSelector,
   state => state.isNewFetching
);

const statisticSelector = createSelector(
   innerStateSelector,
   state => state.statistic
);


const isFilterFetchingSelector = createSelector(
   innerStateSelector,
   state => state.isFilterFetching
);

const isEmptyByFilterSelector = createSelector(
   innerStateSelector,
   state => state.isEmptyByFilter
);
const activeStoreSelector = createSelector(
   innerStateSelector,
   state => state.activeStore
);
const collectionsSelector = createSelector(
   innerStateSelector,
   state => state.collections
);

const ownersSelector = createSelector(
   innerStateSelector,
   state => state.owners
);
const activeCollectionSelector = createSelector(
   innerStateSelector,
   state => state.activeCollection
);
const defaultCollectionsSelector = createSelector(
   innerStateSelector,
   state => state.defaultCollections
);
const customCollectionsSelector = createSelector(
   innerStateSelector,
   state => state.customCollections
);
const categoryActionErrorSelector = createSelector(
   innerStateSelector,
   state => state.categoryActionError
);
const newItemErrorMessageSelector = createSelector(
   innerStateSelector,
   state => state.newItemErrorMessage
);
const newStoreSelector = createSelector(
   innerStateSelector,
   state => state.newStore
);

const updateErrorSelector = createSelector(
   innerStateSelector,
   state => state.updateError
);

const isFetchingResourcesSelector = createSelector(
   innerStateSelector,
   state => state.isFetchingResources
);

const storeImgSelector =  createSelector(
   innerStateSelector,
   state => state.storeImg
);

const openDeleteModalSelector =  createSelector(
   innerStateSelector,
   state => state.openDeleteModal
);
const newItemButtonDisabledSelector =  createSelector(
   innerStateSelector,
   state => state.newItemButtonDisabled
);

const openStatusModSelector = createSelector(
   innerStateSelector,
   state => state.openStatusMod
);

const shippingZoneModal = createSelector(
   innerStateSelector,
   state => state.shippingZoneModal
)

const storeCategoriesSelector = createSelector(
   innerStateSelector,
   state => state.categoriesList
)

const checkedShippingZones = createSelector(
   innerStateSelector,
   state => state.activeStore.shipping_zones
)

const initialActiveStoreSelector = createSelector(
   innerStateSelector,
   state => state.initialActiveStore
)

const newBundlesSelector = createSelector(
   innerStateSelector,
   state => state.newBundle
)
const isInitedStoreSelector = createSelector(
   innerStateSelector,
   state => state.isInited
)

const storeValidationNumbersSelector = createSelector(
   innerStateSelector,
   state => state.storeValidationNumbers
)

const storeScrollPositionAndFiltersSelector = createSelector(
   innerStateSelector,
   state => state.scrollPositonAndFilters
)

const orderRequestsSelector = createSelector(
   innerStateSelector,
   state => state.orderRequests
)

const orderRequestFormsSelector = createSelector(
   innerStateSelector,
   state => state.orderRequestForms
)

const newBundleErrorsSelector = createSelector(
   innerStateSelector,
   state => state.newBundleErrors
)

const initialBundleStateSelector = createSelector(
   innerStateSelector,
   state => state.initialBundleState
)

const imageLoaderSelector = createSelector(
   innerStateSelector,
   state => state.imageLoader
)

const activBundleSelector = createSelector(
   innerStateSelector,
   state => state.activBundle
)

const initalActiveBundelStateSelector = createSelector(
   innerStateSelector,
   state => state.initalActiveBundelState
)

const activeBundlesErrorsSelector = createSelector(
   innerStateSelector,
   state => state.bundlesErrors
)

const activeOrderRequestSelector = createSelector(
   innerStateSelector,
   state => state.activeOrderRequest
)

const activeOrderRequestPageLoadingSelector = createSelector(
   innerStateSelector,
   state => state.activeOrderRequestPageLoading
)

export {
   storeSelector,
   fetchingSelector,
   isEmptySelector,
   statisticSelector,
   newFetchingSelector,
   isFilterFetchingSelector,
   isEmptyByFilterSelector,
   activeStoreSelector,
   collectionsSelector,
   ownersSelector,
   activeCollectionSelector,
   defaultCollectionsSelector,
   customCollectionsSelector,
   categoryActionErrorSelector,
   newItemErrorMessageSelector,
   newStoreSelector,
   updateErrorSelector,
   newItemButtonDisabledSelector,

   isFetchingResourcesSelector,
   storeImgSelector,
   openDeleteModalSelector,
   openStatusModSelector,
   shippingZoneModal,
   storeCategoriesSelector,
   checkedShippingZones,
   initialActiveStoreSelector,
   isInitedStoreSelector,

   storeValidationNumbersSelector,
   storeScrollPositionAndFiltersSelector,
   orderRequestsSelector,
   orderRequestFormsSelector,

   //Content bundles
   newBundlesSelector,
   newBundleErrorsSelector,
   initialBundleStateSelector,
   imageLoaderSelector,
   activBundleSelector,
   initalActiveBundelStateSelector,
   activeBundlesErrorsSelector,

   activeOrderRequestSelector,
   activeOrderRequestPageLoadingSelector,
}
